import React from 'react'
import { NewWindowIcon } from '../../../ui/gov-messages'
import Attachment from './attachment'

const addFile = (event, values, onChange) => {
  const file = event.target.files[0]

  if (file) {
    const reader = new FileReader()

    reader.onload = (readerEvent) => {
      const binaryString = btoa(readerEvent.target.result)
      const blob = {
        content: `${binaryString}`,
        type: 'ACC002',
        name: file.name,
        size: file.size,
        mime: file.type
      }

      onChange('evidence', [...values.evidence, blob])
    }
    reader.readAsBinaryString(file)
  }
}

const AddSupportingEvidenceForm = (props) => {
  const { values, onChange, limit } = props
  return (
    <fieldset>
      <legend>Add evidence</legend>
      <div id='evidenceHeader'>
        <div>
          <strong>Attach Evidence</strong>
          <br />
          Government file limit: 5.4mb. PDF, PNG, JPG, TIFF only.
        </div>
        {values.evidence && values.evidence.length < limit && (
          <div>
            <input
              type='file'
              id='file'
              onChange={(event) => addFile(event, values, onChange)}
              accept='.jpg, .png, .pdf, tiff'
            />
            <label htmlFor='file'>
              Attach
              <NewWindowIcon />
            </label>
          </div>
        )}
      </div>
      {values.evidence && values.evidence.map((_, idx) => {
        return <Attachment key={idx} idx={idx} {...props} />
      })}
    </fieldset>
  )
}

export default AddSupportingEvidenceForm



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/add-supporting-evidence.js